const basicCampaignsPath = (routePath = '') =>
  `personal-campaigns${routePath && '/'}${routePath}`;

export const getCampaigns = () => basicCampaignsPath();
export const getCampaign = (id: string) => basicCampaignsPath(id);
export const createCampaign = () => basicCampaignsPath();
export const updateCampaign = (id: string) => basicCampaignsPath(id);
export const lauchCampaign = (id: string) => basicCampaignsPath(`${id}/launch`);
export const pauseCampaign = (id: string) => basicCampaignsPath(`${id}/pause`);
export const importCsv = (id: string) => basicCampaignsPath(`${id}/csv-import`);
export const getPersonalCampaignLeads = (campaignId: string) =>
  basicCampaignsPath(`${campaignId}/leads`);

const basicPersonalLeadsPath = (routePath = '') =>
  `personal-campaign-leads${routePath && '/'}${routePath}`;
export const getPersonalCampaignLeadCounts = (campaignId: string) =>
  basicPersonalLeadsPath(`counts?personalCampaignId=${campaignId}`);
export const createPersonalLead = (campaignId: string) =>
  basicCampaignsPath(`${campaignId}/create-lead`);
